
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexgqfbrf2GlltWfinO3dVjSJ7MrOjuvlN4x9w2JMJ9nrMMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/index.vue?macro=true";
import { default as indexAw_45yrZXxINRPWmHoerQsyl0cwmvmFabLOR7KVrwBLUMMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/index.vue?macro=true";
import { default as history6NBKvVHBpFwx5t5pzaRX3UeygcFMJpUzMCoNREyRF_kMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/history.vue?macro=true";
import { default as walletWzKuSgUK19Q_459CgLdFhY8ZAN7IwEmcbE9uSQYV4wvDYMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet.vue?macro=true";
import { default as bonuses1ZnW2Vp8a1R0LX4qDyOemd7E2m7yBV4QyV3gv1ak4_450Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/bonuses.vue?macro=true";
import { default as contactvTGFLSEETOyBpoHCudwWymaUKyAZWJF_45g9OS2hzp6zYMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/contact.vue?macro=true";
import { default as infoms61pWS7pvs9sd_45HjVb_qgbLoDXoVLhvW1RJDGpZlgQMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/info.vue?macro=true";
import { default as limitsd4_ZHoIT8xHTm5NUJtyI9siz8M2HeeNosFzpQa9kCY8Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/limits.vue?macro=true";
import { default as personal3sk_lkSx4jkKheTN3wXJaFMrLo4JVQiuz6nK6NpnfC0Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/personal.vue?macro=true";
import { default as sessions_45mqD4DIxw6QwScMa1f8kx7fP8xAnuJ67eSQZqLVDszgMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/sessions.vue?macro=true";
import { default as accountGhlSsyv0BEaX74gwr_3L0GT52JYWUzTS_45yDI8QVD_45OoMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/account.vue?macro=true";
import { default as notifications_UfK6ffTrCrn3Wc7ONiha3qqHVY49R7VfugsTcYjeBsMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/notifications.vue?macro=true";
import { default as settings0rgQyf_45gv9CVMwXvhHJXaT4kgOuwk6DIwFVDbqaq8rsMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings.vue?macro=true";
import { default as profilewizI82qvKIoX26k8S6AIkjMgZ3gqxjKPUA19db3Ruq4Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/profile.vue?macro=true";
import { default as supportSWJHNwUG2bbT5yTV7H_w6KikKS_45obdxgchmt8zaA_45MgMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/support.vue?macro=true";
import { default as referral3BfXXPf9hmTx_Ao0qQ_njAGRBoH2mF8wIRFth7m2UsEMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/referral.vue?macro=true";
import { default as _91_46_46_46slug_93jJmGy5TnSl1YTYL3J31SA0L5Kd2AMJVk7nclQY0pwicMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/[...slug].vue?macro=true";
import { default as _91pageIdentity_93ZorrqHjDgIICMzcLR7KpkAcnZBTGPk2pPtoIZKayUasMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/questions/[pageIdentity].vue?macro=true";
import { default as questions6ZgGFgQxyABnAgSxNdU9G9ArLc7cq_vEmdmDcRIK6ZcMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/questions.vue?macro=true";
import { default as indexXuyfsBd1BMMSQb1y_1PzSshFTYpW6qfv9VZRvZHQT0kMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/index.vue?macro=true";
import { default as autologinQHIK6wc_455sAPi1FJqrwP2Pjn3BKFMlRJE1kJ6UVP5f4Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/autologin.vue?macro=true";
import { default as redirect_46clientrHNVmxz5_SMthv9Yy1fd88_2Tk2HerpNIXM8KtpaHesMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/redirect.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/platform/customer-frontends/wincasino/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91_46_46_46slug_93Vuta6cesY7VzT9QO3gBnheAEqSCRIa4kdNVvlW8v2DEMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/sport/[...slug].vue?macro=true";
import { default as welcome_45packageBrrjfsGQA2H992n72KpD2sLnI8RZVCraYBX9VlK9YysMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/welcome-package.vue?macro=true";
import { default as favorites_46clientL4d9XhIC_45EYkW49WYNl1jwYYBPuyAowmLa6ivrB6Q5IMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/favorites.client.vue?macro=true";
import { default as _91id_93_46clientB51102Uc_45exLk3pqkjoD3VcT5_rKUJhqDdBjAG0qOaYMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/game/[id].client.vue?macro=true";
import { default as _91_46_46_46params_93cq_45PGAQ0fy0d_458SfSBp04vZJ3D6WIwy0E8bxTwHe0t8Meta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/[...params].vue?macro=true";
import { default as _91pageIdentity_93f7_8c6L8S4psXkn5OHkDS2AhTY_rVP7zDJiNvvQpFOUMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/bonus/[pageIdentity].vue?macro=true";
import { default as indexSrBnXxKg4pWKIvfC43WpKwsiylfXui8FM4MxKeicB8oMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/games/providers/index.vue?macro=true";
import { default as _91pageIdentity_93XvsDUnXdHCjegh_WnWatuLT4Bw7Iyqh20GabMkGG_45nQMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/static/[pageIdentity].vue?macro=true";
import { default as recently_45played_46client5e9qnLA_EzArvFl7kqIEmiF1Zfb_450qYK4Obkv5U9vHwMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93rXpsqV7KqxOMPeOA_45wCjnQJ1uFYX99nvw6sAoSJoI8UMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/bonus/welcome/[pageIdentity].vue?macro=true";
import { default as callbackSzBnQoBTFedhHWCOGfCg4KIYnaRrJ1oZd9QmMPdEzYQMeta } from "/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/social/[connection]/callback.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/index.vue")
  },
  {
    name: walletWzKuSgUK19Q_459CgLdFhY8ZAN7IwEmcbE9uSQYV4wvDYMeta?.name,
    path: "/wallet",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet.vue"),
    children: [
  {
    name: "wallet",
    path: "",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/index.vue")
  },
  {
    name: "wallet-history",
    path: "history",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/wallet/history.vue")
  }
]
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/bonuses.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/contact.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile.vue"),
    children: [
  {
    name: "profile-info",
    path: "info",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/limits.vue")
  },
  {
    name: "profile-personal",
    path: "personal",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/personal.vue")
  },
  {
    name: "profile-sessions",
    path: "sessions",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/sessions.vue")
  },
  {
    name: "profile-settings",
    path: "settings",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings.vue"),
    children: [
  {
    name: "profile-settings-account",
    path: "account",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/account.vue")
  },
  {
    name: "profile-settings-notifications",
    path: "notifications",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/profile/settings/notifications.vue")
  }
]
  }
]
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/support.vue")
  },
  {
    name: "referral",
    path: "/referral",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/referral.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/[...slug].vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questions6ZgGFgQxyABnAgSxNdU9G9ArLc7cq_vEmdmDcRIK6ZcMeta || {},
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "games",
    path: "/games",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/index.vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/autologin.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    meta: redirect_46clientrHNVmxz5_SMthv9Yy1fd88_2Tk2HerpNIXM8KtpaHesMeta || {},
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/redirect.client.vue"))
  },
  {
    name: "sport-slug",
    path: "/sport/:slug(.*)*",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/sport/[...slug].vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/welcome-package.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/favorites.client.vue"))
  },
  {
    name: "game-id",
    path: "/game/:id()",
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/game/[id].client.vue"))
  },
  {
    name: "games-params",
    path: "/games/:params(.*)*",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/[...params].vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "games-providers",
    path: "/games/providers",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/games/providers/index.vue")
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/static/[pageIdentity].vue")
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/recently-played.client.vue"))
  },
  {
    name: "bonus-welcome-pageIdentity",
    path: "/bonus/welcome/:pageIdentity()",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/bonus/welcome/[pageIdentity].vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/builds/platform/customer-frontends/wincasino/skeleton/pages/auth/social/[connection]/callback.vue")
  }
]